
export interface CardInfo {
    cardCompany: string
    cardName: string
    cardType: string
}

export interface WorkspaceCard {
    workspaceId: string
    cardNumber: string
    default: boolean
    email?: string
    cardInfo?: CardInfo
}

export enum CurrencyUnit {
    KRW = 'KRW',
    USD = 'USD'
}

export interface Billing {
    currencyUnit: CurrencyUnit
    amount: number
}

export enum TransactionType {
    WORKSPACE_SUBSCRIPTION = 'workspace_subscription',
    SAMPLE = "sample"
}

export interface TransactionBase {
    workspaceId: string
    card: WorkspaceCard
    billing: Billing
    type: TransactionType
}

export interface Transaction extends TransactionBase {
    _id: string;
    createdAt: string;
    updatedAt: string;
}
